import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import UserGuideEdit from "./UserGuideEdit";
import { useSakusasEditableTextGet } from "hooks/sakusas/editable_text/useSakusasEditableTextGet";
import parse from "html-react-parser";

const MODES = {
  VIEW: "view",
  EDIT: "edit",
};

export const USER_GUIDE_TEXT = "user_guide";

const UserGuide = () => {
  const [mode, setMode] = useState<string>(MODES.VIEW);
  const editableText = useSakusasEditableTextGet(USER_GUIDE_TEXT); // slug1

  useEffect(() => {
    console.log("editableText", editableText);
  }, [editableText]);

  const editClickHandle = () => {
    setMode(MODES.EDIT);
  };

  return (
    <div>
      {mode === MODES.VIEW && (
        <div>
          <Button variant={"outlined"} onClick={editClickHandle}>
            EDIT
          </Button>
          <div>{parse(editableText !== null ? editableText.content : "")}</div>
        </div>
      )}
      {mode === MODES.EDIT && (
        <UserGuideEdit cancelHandle={() => setMode(MODES.VIEW)} />
      )}
    </div>
  );
};

export default UserGuide;
